module.exports = __webpack_public_path__ + "static/media/stepOneFailed.4afabca4.png";